import { render, staticRenderFns } from "./AbastecimentosRequisicoes.vue?vue&type=template&id=1e3ad9d6&scoped=true"
import script from "./AbastecimentosRequisicoes.vue?vue&type=script&lang=js"
export * from "./AbastecimentosRequisicoes.vue?vue&type=script&lang=js"
import style0 from "./AbastecimentosRequisicoes.vue?vue&type=style&index=0&id=1e3ad9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3ad9d6",
  null
  
)

export default component.exports